import { Icon } from "@sellar-io/components";
import { NavigationOverlay } from "./NavigationOverlay";
import { SellarCreditNavigationContent } from "./SellarCreditNavigationContent";

export const SellarCreditNavigationOverlay = () => (
  <NavigationOverlay
    id="sellar-credit"
    title="Sellar Credit"
    contentClassName="gap-2 p-0"
    trigger={(props) => (
      <button
        {...props}
        type="button"
        className="inline-flex min-h-11 shrink-0 items-center gap-1 text-sm font-medium whitespace-nowrap text-zinc-800 hover:text-[#a34fd2] focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-purple-600 aria-expanded:text-[#8c23c7]"
      >
        Sellar Credit <Icon icon="CHEVRON_DOWN" size="16px" />
      </button>
    )}
  >
    <h2 className="shrink-0 px-4 pt-4 pb-2 text-base leading-[23px] font-semibold text-zinc-800">
      Sellar Credit
    </h2>
    <SellarCreditNavigationContent />
  </NavigationOverlay>
);
